import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MuCookieService } from '../../shared/sharedServices/mu-cookie.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard  {
  tokenLocal: string;
  muDataLocal: string;

  constructor(private router: Router, private muCookieService: MuCookieService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.tokenLocal = this.muCookieService.getCookie('token-mu');
    this.muDataLocal = localStorage.getItem('mu-data');
    if (this.tokenLocal.length > 1 && this.muDataLocal) {
      return true;
    } else {
      this.router.navigate(['page/login']);
      return false;
    }
  }
}
